export class WebsiteTranslationConfig {
    public websiteMetrics: any; // ITranslationConfig; // jmstodo make object
    public websiteLabels: any; // ITranslationConfig; // jmstodo make object
    public websiteReportTitles: any;
    public websiteChartDimensions: any; // ITranslationConfig;
    public websiteChannels: any;
}
